<!-- Lamp Ble Config Details -->
<template>
  <div>
      <!-- Details input config disabled -->
      <b-row v-if="currentLamp.radioModulePresence==true" class="m-2">
        <b-col sm="12">{{ $t("details_lamp.radio_module_presence") }}</b-col>
      </b-row> 

      <hr>
      <!-- Details input config as button -->
      <b-row v-if="currentLamp.inputButton && currentLamp.inputButton.onOffButton==true" class="m-2">
        <b-col sm="12"><strong style="color:#009DE0">{{ $t("details_lamp.input_config_button") }}</strong><img src="img/pushbutton.png" style="height:15px;" class="pl-2"></b-col>
        <!-- modalità -->
        <b-col sm="5" class="pt-2">{{ $t("details_lamp.input_config_mode") }} : </b-col>
        <b-col sm="7" class="pt-2" v-if="currentLamp.inputButton.pushToDimmButton==true && currentLamp.inputButton.onOffButton==true" >{{ $t("details_lamp.input_config_button_push_to_dimm") }}</b-col>
        <b-col sm="7" class="pt-2" v-if="currentLamp.inputButton.pushToDimmButton==false && currentLamp.inputButton.onOffButton==true" >{{ $t("details_lamp.input_config_button_on_off") }}</b-col>
        <b-col sm="7" class="pt-2" v-if="currentLamp.inputButton.sceneButton==true" >{{ $t("details_lamp.input_config_button_scene") }}</b-col>
         <!-- attivo su zona o gruppo -->
         <b-col sm="12"><lamp-ble-zone-local-plant :currentSetting="currentLamp.inputButton" :currentGroup="currentLamp.group"></lamp-ble-zone-local-plant></b-col>
         <!-- timer -->
         <b-col sm="5" class="pt-2">{{$t("details_lamp.input_config_button_timeout") }} :</b-col>
         <b-col sm="7" class="pt-2">{{currentLamp.inputButton.shutDownTimer/60}} min.</b-col>
      </b-row>

      <!-- Details input config as presence sensor -->
      <b-row v-if="currentLamp.presenceSensor && (currentLamp.presenceSensor.occupancyMode==true || currentLamp.presenceSensor.vacancyMode==true)" class="m-2">
        <b-col sm="12"><strong style="color:#009DE0;">{{ $t("details_lamp.input_config_sensor") }}</strong><img src="img/person.png" style="height:15px;" class="pl-2"></b-col>
        <!-- modalità -->
        <b-col sm="5" class="pt-2">{{ $t("details_lamp.input_config_mode") }} : </b-col>
        <b-col sm="7" class="pt-2" v-if="currentLamp.presenceSensor.occupancyMode==true && currentLamp.presenceSensor.vacancyMode==false" >{{ $t("details_lamp.input_config_sensor_occupancy") }}</b-col>
        <b-col sm="7" class="pt-2" v-if="currentLamp.presenceSensor.occupancyMode==false && currentLamp.presenceSensor.vacancyMode==true" >{{ $t("details_lamp.input_config_sensor_vacancy") }}</b-col>
        <b-col sm="7" class="pt-2" v-if="currentLamp.presenceSensor.occupancyMode==true && currentLamp.presenceSensor.vacancyMode==true" >{{ $t("details_lamp.input_config_sensor_corridor") }}</b-col>
        <!-- attivo su zona o gruppo -->
        <b-col sm="12"><lamp-ble-zone-local-plant :currentSetting="currentLamp.presenceSensor" :currentGroup="currentLamp.group"></lamp-ble-zone-local-plant></b-col>
        <!-- livello di accensione con occupancy or corridor mode -->
        <b-col sm="5" class="pt-2" v-if="currentLamp.presenceSensor.occupancyMode==true">{{ $t("details_lamp.input_config_sensor_level_presence") }} :</b-col>
        <b-col sm="7" class="pt-2" v-if="currentLamp.presenceSensor.occupancyMode==true">{{currentLamp.presenceSensor.presenceDimmer}} %</b-col>
        <b-col sm="5" class="pt-2" v-if="currentLamp.presenceSensor.occupancyMode==true">{{$t("details_lamp.input_config_sensor_timeout_presence") }} :</b-col>
        <b-col sm="7" class="pt-2" v-if="currentLamp.presenceSensor.occupancyMode==true">{{currentLamp.presenceSensor.presenceTimeout/60}} min.</b-col>
        <!-- livello di spegnimento con vacancy or corridor mode -->
        <b-col sm="5" class="pt-2" v-if="currentLamp.presenceSensor.vacancyMode==true">{{ $t("details_lamp.input_config_sensor_level_vacancy") }} :</b-col>
        <b-col sm="7" class="pt-2" v-if="currentLamp.presenceSensor.vacancyMode==true">{{currentLamp.presenceSensor.vacancyDimmer}} %</b-col>
        <b-col sm="5" class="pt-2" v-if="currentLamp.presenceSensor.vacancyMode==true">{{$t("details_lamp.input_config_sensor_timeout_vacancy") }} :</b-col>
        <b-col sm="7" class="pt-2" v-if="currentLamp.presenceSensor.vacancyMode==true">{{currentLamp.presenceSensor.vacancyTimeout/60}} min.</b-col>
        <!-- rampa -->
        <b-col sm="12" class="pt-2" v-if="currentLamp.presenceSensor.rampa==false">{{ $t("details_lamp.input_config_sensor_rampa") }}</b-col> 
      </b-row>

      <!-- Details input config disabled -->
      <b-row v-if="currentLamp.inputStatus=='0'" class="m-2">
        <b-col sm="12"><strong>{{ $t("details_lamp.input_config_disable") }}</strong></b-col>
      </b-row>  

      <!-- Details light sensor -->
      <div v-if="currentLamp.lightSensorPresence==true">
      <hr>  
      <b-row  class="m-2">
        <b-col sm="12"><strong style="color:#009DE0;">{{ $t("details_lamp.photosensor_presence") }}</strong><img src="img/fotosensor.png" style="height:15px;" class="pl-2"></b-col>
        <!-- modalità di funzionamento -->
        <b-col sm="5" class="pt-2">{{ $t("details_lamp.photosensor_mode") }} : </b-col>
        <b-col sm="7" class="pt-2" v-if="currentLamp.lightSensor.autodimmerEnabled==true && currentLamp.lightSensor.isMaster==true" >{{ $t("details_lamp.dimmer_master") }}</b-col>
        <b-col sm="7" class="pt-2" v-if="currentLamp.lightSensor.autodimmerEnabled==true && currentLamp.lightSensor.isMaster==false" >{{ $t("details_lamp.dimmer_auto") }}</b-col>
        <b-col sm="7" class="pt-2" v-if="currentLamp.lightSensor.autodimmerEnabled==false && currentLamp.lightSensor.isMaster==false" >{{ $t("details_lamp.dimmer_disable") }}</b-col>
        <!-- attivo su zona o gruppo -->
        <b-col sm="12" v-if="currentLamp.lightSensor.autodimmerEnabled==true && currentLamp.lightSensor.isMaster==true"><lamp-ble-zone-local-plant :currentSetting="currentLamp.lightSensor" :currentGroup="currentLamp.group"></lamp-ble-zone-local-plant></b-col>
        <!-- autocalib -->
        <b-col sm="5" class="pt-2">{{ $t("details_lamp.lamp_autocalib") }} : </b-col>
        <b-col sm="7" class="pt-2" v-if="currentLamp.lightSensor.autocalibEnabled==true">{{ $t("details_lamp.enable") }}</b-col>
        <b-col sm="7" class="pt-2" v-if="currentLamp.lightSensor.autocalibEnabled==false">{{ $t("details_lamp.disable") }}</b-col> 
      </b-row>
      </div>

      
      <hr>

  </div>
</template>

<script>
import LampBleZoneLocalPlant from '@/components/SDBLampDetails/LampBleZoneLocalPlant.vue';
export default {
  name: "LampBleConfigDetails",
  components:{
    LampBleZoneLocalPlant
  },
  props: {
    currentLamp: null
  },

  
  data()
  {
    return {

    };
  },

}
</script>
